module.exports = __webpack_public_path__ + "img/outlet.bd36827b.svg";